/**
 * Everart Newsletter Popup — controller della card non modale.
 * Accompagna sections/everart-newsletter-popup.liquid.
 *
 * Timing:
 * - Se il visitatore deve ancora rispondere al banner cookie (Shopify Customer Privacy API),
 *   il timer parte DOPO la risposta (evento visitorConsentCollected).
 * - Se il consenso è già stato dato, o il banner non è richiesto, il timer parte dal caricamento.
 * - Se l'API non si carica entro 1,5 s, si procede come "banner non richiesto".
 *
 * Cookie (everart:newsletter-popup):
 * - chiuso dal visitatore: 14 giorni (valore "dismissed").
 * - iscrizione riuscita: 365 giorni (valore "subscribed"). Chiudere la card dopo l'iscrizione
 *   non sovrascrive questo cookie.
 *
 * Messaggi server-side (dopo il POST del form Shopify): la card compare subito, senza attesa.
 * Non sposta il focus: la card non è modale. ESC chiude.
 */
(function () {
  var COOKIE = 'everart:newsletter-popup';
  var CLOSE_MS = 200;
  var PRIVACY_TIMEOUT_MS = 1500;

  var root = document.querySelector('.everart-np');
  if (!root) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.location.pathname === '/challenge') return;

  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 0) * 1000;
  var expDismissed = parseInt(root.getAttribute('data-expiry-dismissed'), 10) || 14;
  var expSubscribed = parseInt(root.getAttribute('data-expiry-subscribed'), 10) || 365;

  var successMsg = root.querySelector('.everart-np__msg[role="status"]');
  var errorMsg = root.querySelector('.everart-np__msg--error');
  var isSubscribed = !!successMsg;

  function getCookie(name) {
    var match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return match ? match[2] : null;
  }

  function setCookie(value, days) {
    document.cookie = COOKIE + '=' + value + '; max-age=' + days * 86400 + '; path=/; samesite=lax';
  }

  function show() {
    if (!root.hidden) return;
    root.hidden = false;
  }

  function hide() {
    if (root.hidden || root.classList.contains('is-leaving')) return;
    root.classList.add('is-leaving');
    window.setTimeout(function () {
      root.hidden = true;
      root.classList.remove('is-leaving');
    }, CLOSE_MS);
  }

  function dismiss() {
    if (!isSubscribed) setCookie('dismissed', expDismissed);
    hide();
  }

  // Attende che la Customer Privacy API sia pronta; se non arriva in tempo, prosegue senza.
  function whenPrivacyReady(callback) {
    var ready = window.Shopify && window.Shopify.customerPrivacy;
    if (ready) {
      callback(ready);
      return;
    }
    var called = false;
    function finish() {
      if (called) return;
      called = true;
      callback(window.Shopify && window.Shopify.customerPrivacy);
    }
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', finish, { once: true });
    window.setTimeout(finish, PRIVACY_TIMEOUT_MS);
  }

  function scheduleShow() {
    window.setTimeout(show, delayMs);
  }

  root.querySelector('[data-np-close]').addEventListener('click', dismiss);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) dismiss();
  });

  // Iscrizione riuscita: cookie lungo e card visibile con il messaggio, senza attesa.
  if (successMsg) {
    setCookie('subscribed', expSubscribed);
    show();
    return;
  }

  // Errore di validazione dopo il POST: mostra subito la card con l'errore.
  if (errorMsg) {
    show();
    return;
  }

  // Già chiuso di recente: niente popup.
  if (getCookie(COOKIE)) return;

  whenPrivacyReady(function (cp) {
    var bannerPending = !!(cp && typeof cp.shouldShowGDPRBanner === 'function' && cp.shouldShowGDPRBanner());
    if (!bannerPending) {
      scheduleShow();
      return;
    }
    document.addEventListener('visitorConsentCollected', function onConsent() {
      document.removeEventListener('visitorConsentCollected', onConsent);
      scheduleShow();
    });
  });
})();

